import styled from 'styled-components';


type RootProps = {
	size?: 'small' | 'medium' | 'large';
	fullWidth?: boolean;
}

const Root = styled.div<RootProps>`
	position: relative;
	display: inline-block;
	width: auto;
	height: auto;

	& i ~ *,
	& * ~ i {
		margin-left: 10px;
	}

	${p => p.size === 'small' && `
		& i ~ *,
		& * ~ i {
			margin-left: 4px;
		}
	`}

	${p => p.fullWidth && `
		width: 100%;
	`}
`;

export {
	Root
}